import { css } from '@emotion/react'
import { spacing, colors, borderRadius } from '@retailer-platform/shared-components'
import { type DomainMessages } from 'domains/collections/utils/domain/intl'
import { collectionsFormTestIds } from 'domains/collections/components/collections-form/utils/collectionsForm.utils'

export const collectionFormTileOptions = {
  identifier: 'tile.image',
  labelId: 'collectionsDomain.collectionsForm.form.fields.tileImage.label' as DomainMessages,
  footnote: 'collectionsDomain.collectionsForm.form.fields.tileImage.footnote' as DomainMessages,
  errorMessage:
    'collectionsDomain.collectionsForm.form.fields.tileImage.error.required' as DomainMessages,
  'data-testid': collectionsFormTestIds.tileField,
  previewDimensions: { width: 135, height: 135 },
  imageDimensions: { width: 89, height: 89 },
}

const headerStyles = css({
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: colors.GRAYSCALE.X20,
  borderTopRadius: borderRadius.X4,
  paddingTop: spacing.X28,
  paddingBottom: spacing.X28,
})

export const collectionFormWebHeaderOptions = {
  identifier: 'header.webImage',
  labelId: 'collectionsDomain.collectionsForm.section.header.webHeader.label' as DomainMessages,
  footnote: 'collectionsDomain.collectionsForm.section.header.webHeader.footnote' as DomainMessages,
  errorMessage:
    'collectionsDomain.collectionsForm.section.header.webHeader.error.required' as DomainMessages,
  'data-testid': collectionsFormTestIds.webHeaderField,
  previewDimensions: { width: 672, height: 135 },
  imageDimensions: { width: 1400, height: 152 },
  styles: headerStyles,
}

export const collectionFormMobileHeaderOptions = {
  identifier: 'header.mobileImage',
  labelId: 'collectionsDomain.collectionsForm.section.header.mobileHeader.label' as DomainMessages,
  footnote:
    'collectionsDomain.collectionsForm.section.header.mobileHeader.footnote' as DomainMessages,
  errorMessage:
    'collectionsDomain.collectionsForm.section.header.mobileHeader.error.required' as DomainMessages,
  'data-testid': collectionsFormTestIds.mobileHeaderField,
  previewDimensions: { width: 448, height: 135 },
  imageDimensions: { width: 400, height: 140 },
  styles: headerStyles,
}

export const collectionStorefrontBannerOptions = {
  identifier: 'storefrontBanner.bannerImage',
  labelId:
    'collectionsDomain.collectionsForm.section.storefrontBanner.bannerImage.label' as DomainMessages,
  footnote:
    'collectionsDomain.collectionsForm.section.storefrontBanner.bannerImage.footnote' as DomainMessages,
  errorMessage:
    'collectionsDomain.collectionsForm.section.storefrontBanner.bannerImage.error.required' as DomainMessages,
  'data-testid': collectionsFormTestIds.storefrontBannerImageField,
  previewDimensions: { width: 252, height: 135 },
  imageDimensions: { width: 633, height: 270 },
  styles: headerStyles,
}
